import { languageEnglish } from "../i18n";

export const getPageSlugFromPathname = (pathname: string): string => {
  const slug = pathname.slice(1); // remove leading slash
  const parts = slug.split("/"); // split by slashes

  const supportedLangs = [languageEnglish];

  // If first segment is a non-Dutch supported language code, strip it
  if (supportedLangs.includes(parts[0])) {
    return parts.slice(1).join("/");
  }

  return slug;
};
